import React from "react";
import { useHistory } from "react-router-dom";
import OnboardingLayout from "../../../components/onboarding/Layout";
import Title from "../../../components/onboarding/title";
import Divider from "../../../components/onboarding/Divider";
import { Button } from "@shopify/polaris";
import SupportBooking from "../../../components/Calendy/SupportBooking";

const OnboardingSupportBooking = () => {
  const history = useHistory();

  return (
    <OnboardingLayout maxWidth={1100}>
      <Title displayText="Schedule a support call" />
      <p style={{ marginTop: "8px" , alignSelf: "center"}}>
        Your setup is complete. Book a time with our team if you need help getting started.
      </p>

      <Divider />

      <div className="onboarding-support-booking-calendly">
        <SupportBooking />
      </div>

      <div className="onboarding-footer-btn-main display-flex-center">
        <Button primary onClick={() => history.push("/app/markets")}>
          Continue to dashboard
        </Button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingSupportBooking;
